export default __webpack_public_path__ + "static/Abel-Tasman-Coastal-Track-credit-EliDuke-d28d89b9429e5e01f0a63661be536f8f.jpg";